import {
  AiderScreen,
  BodyScreen,
  ContentScreen,
  FullScreen,
} from '@/layouts/page-layout';
import { noticeFlagVar } from '@/graphql/variables';
import { Collapse, Link, Alert } from '@mui/material';
import { Topic, Aider, Recommend } from './modules';
import { useReactiveVar } from '@apollo/client';

export default function Home() {
  const notice_flag = useReactiveVar(noticeFlagVar);

  return (
    <FullScreen>
      <BodyScreen>
        <Collapse in={notice_flag} sx={{ flex: 1 }}>
          <Alert severity="warning" onClose={() => noticeFlagVar(false)}>
            网站功能正在完善中，如果在使用过程中遇到任何问题欢迎提bug。
            <Link
              target="_blank"
              href="https://github.com/sma2lbao/sma2lbao.github.io/issues"
              color="inherit"
            >
              <strong>去提Bug！</strong>
            </Link>
          </Alert>
        </Collapse>
      </BodyScreen>
      <BodyScreen>
        <ContentScreen
          sx={(theme) => ({
            backgroundColor: theme.palette.background.paper,
            paddingLeft: theme.spacing(8),
            paddingRight: theme.spacing(8),
          })}
        >
          <Topic />
          {/* <Divider /> */}
          <Recommend />
        </ContentScreen>
        <AiderScreen
          sticky
          sx={(theme) => ({
            backgroundColor: theme.palette.background.paper,
            width: '100%',
            padding: theme.spacing(2, 2),
            borderLeft: '1px solid',
            borderColor: theme.palette.divider,
          })}
        >
          <Aider />
        </AiderScreen>
      </BodyScreen>
    </FullScreen>
  );
}
